<template>
  <div class="container mt-4">
    <button
      id="mic-toggle"
      class="btn btn btn-outline-light ms-2 rounded-pill"
    >
      <i v-if="volumeUp" class="bi bi-volume-up"></i>
      <i v-else class="bi bi-volume-mute"></i>
    </button>
    <button
      id="speaker-toggle"
      class="btn btn btn-outline-light ms-2 rounded-pill"
    >
      <i v-if="isMuted" class="bi bi-mic-mute"></i>
      <i v-else class="bi bi-mic"></i>
    </button>
    <div class="d-flex justify-content-center mt-4">
      <div class="position-relative" style="width: 1280px; height: 720px">
        <video
          id="panel"
          autoplay
          width="1280"
          height="720"
          class="border rounded shadow"
        ></video>
      </div>
    </div>
  </div>
</template>

<script>
import { RTM } from "agora-rtm-sdk";
import AgoraRTC from "agora-rtc-sdk-ng";
import CryptoJS from "crypto-js";

export default {
  components: {
  },
  data() {
    return {
      localTracks: {
        audioTrack: null,
      },
      gamepadIndex: -1,
      volumeUp: false,
      isMuted: false,
      peerId: null,
    };
  },
  watch: {
    '$route'(to) {
      console.log('Route changed:', to.query);
      if (to.params.session) {
        this.live(to.params.session);
      } else {
        alert('No session found.');
      }
    },
  },
  methods: {
    async readGamepad(rtm, userId) {
      let gamepads = navigator.getGamepads();
      this.gamepadIndex = -1;
      for (let i = 0; i < gamepads.length; i++) {
        if (gamepads[i] != null) {
          //console.log(gamepads[i].id);
          this.gamepadIndex = i;
          break;
        }
      }
      if (this.gamepadIndex == -1) {
        setTimeout(() => {
          this.readGamepad(rtm, userId);
        }, 500);
        return;
      }
      const gamepad = gamepads[this.gamepadIndex];

      const data = {
        buttons: gamepad.buttons.map(button => button.pressed ? 1.0 : 0.0),
        axes: gamepad.axes
      };

      let gamepadData = {
        type: "gamepad",
	data: data,
        timestamp: Date.now(),
      };
      const dataSent = JSON.stringify(gamepadData);
      rtm.publish(userId, dataSent, {channelType: 'USER'});

      setTimeout(() => {
        this.readGamepad(rtm, userId);
      }, 100);
    },
    async live(session) {
      let tokenPlaintext = '';
      try {
        const secretKey = 'botfighting123';
        const decryptedToken = CryptoJS.AES.decrypt(atob(session), secretKey);
        tokenPlaintext = decryptedToken.toString(CryptoJS.enc.Utf8);
      } catch (err) {
        alert('No session found or not started yet.');
        return;
      }

      console.log('Session from live:', tokenPlaintext);
      const roomId = tokenPlaintext.split(":")[0];
      const userId = parseInt(tokenPlaintext.split(":")[1]);
      const rtcToken = tokenPlaintext.split(":")[2];
      const rtmToken = tokenPlaintext.split(":")[3];
      const appId = tokenPlaintext.split(":")[4];
      const botVideoUid = 1000;
      const botAudioUid = 100000 + botVideoUid;
      this.peerId = roomId + "-" + userId;
      console.log("Room ID:", roomId);
      console.log("User ID:", userId);
      console.log("RTC Token:", rtcToken);
      console.log("RTM Token:", rtmToken);
      console.log("App ID:", appId);
      if (
        roomId == undefined ||
        userId == undefined ||
        rtcToken == undefined ||
        rtmToken == undefined ||
        appId == undefined
      ) {
        alert("No session found.");
        return;
      }

      let isAudioAutoplayFailed = false;
      AgoraRTC.onAudioAutoplayFailed = () => {
        if (isAudioAutoplayFailed) return;
        this.volumeUp = false;
        isAudioAutoplayFailed = true;
      };

      var rtcClient = AgoraRTC.createClient({ mode: "rtc", codec: "h264" });
      rtcClient.on("user-published", async (user, mediaType) => {
        console.log("user-published: ", user, mediaType);
        if (mediaType == "video" && user.uid == botVideoUid) {
          await rtcClient.subscribe(user, mediaType);
          console.log("video track subscribed: ", user.uid);
          user.videoTrack.play("panel");
        } else if (mediaType == "audio" && user.uid == botAudioUid) {
          await rtcClient.subscribe(user, mediaType);
          console.log("audio track subscribed: ", user.uid);
          const btn = document.getElementById("mic-toggle");
          btn.onclick = () => {
            if (this.volumeUp) {
              user.audioTrack.stop();
              this.volumeUp = false;
            } else {
              user.audioTrack.play();
              this.volumeUp = true;
            }
          };
        }
      });

      rtcClient.on("user-joined", async (user) => {
        console.log("user-joined: " + user.uid);
      });

      rtcClient.on("user-left", async (user) => {
        console.log("user-left: " + user);
      });

      rtcClient.on("user-unpublished", async (user, mediaType) => {
        console.log("user-unpublished: " + user, mediaType);
      });

      const uid = await rtcClient
        .join(appId, roomId, rtcToken, userId)
        .catch(() => {
          alert("No session found.");
          return;
        });

      console.log("UID:", uid);
      const rtm = new RTM(appId, roomId + "-" + userId);
      rtm.addEventListener('message', (event) => {
        console.log(event.message);
      });

      rtm.addEventListener("status", (event) => {
        const currentState = event.state;
        const changeReason = event.reason;
        console.log(JSON.stringify(event));
        if (currentState === "CONNECTED") {
          console.log("Connected to Agora RTM");
          this.readGamepad(rtm, roomId + "-" + botVideoUid);
        }
        if (changeReason === "TOKEN_EXPIRED") {
          alert("You have reached the end of the session.");
        } else if (changeReason === "SAME_UID_LOGIN") {
          alert("You have logged in from another tab.");
        }
      });
/*
      this.localTracks.audioTrack = await AgoraRTC.createMicrophoneAudioTrack({
        encoderConfig: "music_standard",
      });
      this.localTracks.audioTrack.setEnabled(!this.isMuted);
      const spkBtn = document.getElementById("speaker-toggle");
      spkBtn.onclick = () => {
	if (this.isMuted) {
          this.localTracks.audioTrack.setEnabled(true);
          this.isMuted = false;
        } else {
          this.localTracks.audioTrack.setEnabled(false);
          this.isMuted = true;
	}
      };

      await rtcClient.publish(Object.values(this.localTracks));
*/

      const result = await rtm.login({ token: rtmToken });
      console.log("RTM Login:", result);
    },
  },

  mounted() {
    console.log('Component mounted');
    console.log('Initial route query:', this.$route.query);
    // If we have a session parameter, check the API
    if (this.$route.params.session) {
      this.live(this.$route.params.session);
    }
  },

  beforeUnmount() {
  },

  created() {},
};
</script>

<style scoped>
</style>
